export default {"src":"/_next/static/image/public/images/flags/flag_229.da124ba50ed02cc0d8c753092ab31f17.svg","height":16,"width":25};